// Create new file: common/src/commonMain/kotlin/com/exura/features/legacyplans/domain/mapper/DefaultDateCalculator.kt

package com.exura.features.legacyplans.domain.mapper

import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.atTime
import kotlinx.datetime.plus

class DefaultDateCalculator : DateCalculator {
    override fun calculateDate(baseDate: LocalDateTime, daysToAdd: Int): LocalDateTime {
        return baseDate.date.plus(DatePeriod(days = daysToAdd)).atTime(baseDate.time)
    }
}
